import type { CityConfig } from "@/pages/city-template/types";

export const laGrandeConfig: CityConfig = {
  city: "La Grande",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "la-grande",
  route: "/cities/la-grande",
  title: "Emergency Passport La Grande, OR | Expedited Passport Services Union County",
  metaDescription: "Emergency passport and expedited passport services in La Grande, OR — as fast as 24 hours. Serving Union County, Baker City, Enterprise, and Eastern Oregon. A+ BBB rated registered State Dept. courier. Rush passport renewal for La Grande travelers.",
  h1: "Emergency & Expedited Passport Services in La Grande, Oregon",
  heroSubtitle: "Passport expired before your Canada trip or international departure? Fast Passport Center helps La Grande and Union County travelers get expedited passports in as little as 24 hours. Eastern Oregon's fastest passport courier — no trip to Seattle required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=La%20Grande%20Oregon%20Grande%20Ronde%20Valley%20with%20lush%20green%20valley%20floor%20surrounded%20by%20Blue%20Mountains%20pine%20forests%2C%20warm%20afternoon%20light%20on%20rolling%20green%20fields%20and%20forested%20ridgelines%2C%20dramatic%20sky%20with%20white%20clouds%2C%20eastern%20Oregon%20mountain%20valley%20vista%2C%20photorealistic%20landscape%20photography%20with%20rich%20colors%2C%20no%20text%20or%20signs&width=1800&height=700&seq=la-grande-hero-01&orientation=landscape",
  heroImageAlt: "Grande Ronde Valley and Blue Mountains near La Grande Oregon",
  geoPosition: "45.3246;-118.0877",
  geoPlacename: "La Grande, Oregon",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "About 340 miles northwest — 5+ hours by car",
  },
  nearbyCitiesZips: [
    { name: "La Grande", zips: "97850" },
    { name: "Union", zips: "97883" },
    { name: "Elgin", zips: "97827" },
    { name: "Cove", zips: "97824" },
    { name: "Imbler", zips: "97841" },
    { name: "Island City", zips: "97850" },
    { name: "Baker City", zips: "97814" },
    { name: "Halfway", zips: "97834" },
    { name: "Haines", zips: "97833" },
    { name: "Enterprise", zips: "97828" },
    { name: "Joseph", zips: "97846" },
    { name: "Wallowa", zips: "97885" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit to our facility required. Complete your expedited passport order from La Grande or anywhere in Union County." },
    { icon: "ri-truck-line", title: "Overnight Shipping from La Grande", desc: "Ship your documents overnight from FedEx or UPS in La Grande or Baker City. Your documents arrive at our processing center the next morning." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is professionally reviewed before submission — especially critical for remote Union County applicants far from a regional passport agency." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport agency, bypassing public appointment backlogs that can stretch weeks out." },
  ],
  testimonials: [
    {
      name: "Kevin S.",
      location: "La Grande, OR",
      rating: 5,
      text: "Planned a Canada hunting trip and realized my passport had expired 6 months earlier. Fast Passport Center got my renewal done in 6 days. Shipped from the FedEx in La Grande — they even confirmed everything was correct before I shipped. Saved my hunt.",
      service: "Passport Renewal",
    },
    {
      name: "Linda R.",
      location: "Baker City, OR",
      rating: 5,
      text: "Our daughter needed a passport for a study abroad program in France. Fast Passport Center walked us through the whole process — the acceptance step was the part I was nervous about. They explained it perfectly. Passport arrived in 8 days.",
      service: "Child Passport",
    },
    {
      name: "Tom H.",
      location: "Enterprise, OR",
      rating: 5,
      text: "Emergency passport situation — unexpected family trip to Mexico. Fast Passport Center answered the phone on a Saturday, guided us through the entire process, and had the passport in 5 days. Can't say enough good things.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "la-grande-post",
      name: "La Grande Post Office",
      type: "USPS Passport Acceptance",
      address: "1202 Washington Ave",
      city: "La Grande",
      state: "OR",
      zip: "97850",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "La Grande — primary Union County location",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Union County. Appointment required — scheduling can be limited. Call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "baker-city-post",
      name: "Baker City Post Office",
      type: "USPS Passport Acceptance",
      address: "1550 Dewey Ave",
      city: "Baker City",
      state: "OR",
      zip: "97814",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Baker City — about 45 miles south via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Baker County option for La Grande area travelers. Appointment availability varies — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "union-county-clerk",
      name: "Union County Clerk",
      type: "County Passport Acceptance",
      address: "1001 4th St, Room 19",
      city: "La Grande",
      state: "OR",
      zip: "97850",
      phone: "541-963-1006",
      hours: "Mon–Fri 8am–5pm (by appointment)",
      distance: "La Grande — County Courthouse",
      website: "https://www.oregonblue.com/union-county/",
      websiteLabel: "Union County Website",
      notes: "County clerk passport acceptance. Appointment required — call ahead to confirm services. Sometimes has better availability than USPS.",
      icon: "ri-government-line",
    },
    {
      id: "enterprise-post",
      name: "Enterprise Post Office",
      type: "USPS Passport Acceptance",
      address: "101 NW 1st St",
      city: "Enterprise",
      state: "OR",
      zip: "97828",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3pm",
      distance: "Enterprise (Wallowa County) — about 60 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Option for Wallowa County residents and those in the northeast Oregon corner. Limited hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "pendleton-post-opt",
      name: "Pendleton Post Office",
      type: "USPS Passport Acceptance",
      address: "104 SW Dorion Ave",
      city: "Pendleton",
      state: "OR",
      zip: "97801",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Pendleton — about 50 miles northwest via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Pendleton option for La Grande area travelers who need a larger post office. Better appointment availability for some services.",
      icon: "ri-mail-line",
    },
    {
      id: "ontario-post-opt",
      name: "Ontario Post Office",
      type: "USPS Passport Acceptance",
      address: "64 SW 2nd Ave",
      city: "Ontario",
      state: "OR",
      zip: "97914",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Ontario — about 110 miles east near Idaho border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Ontario option for Malheur County and Idaho border area applicants.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in La Grande, Oregon?",
      a: "Yes. Through Fast Passport Center, La Grande and Union County travelers can get an emergency passport in as fast as 24 hours. La Grande does not have a regional passport agency — the closest is Seattle, over 340 miles away. Our registered courier service provides La Grande travelers with priority processing without requiring a 5-hour drive.",
    },
    {
      q: "How do I expedite a passport from La Grande, OR?",
      a: "Expediting a passport from La Grande is easy with Fast Passport Center. Start your order online, receive your personalized document checklist, and ship overnight from the FedEx or UPS location in La Grande. We handle expedited processing through reserved agency channels. Processing can be as fast as 2–9 business days.",
    },
    {
      q: "Where is the nearest passport office to La Grande, Oregon?",
      a: "The nearest regional passport agency to La Grande is Seattle, about 340 miles northwest (5+ hours each way). That agency only serves documented emergencies with travel within 14 days. For most La Grande residents, Fast Passport Center's registered courier service is significantly faster and more practical.",
    },
    {
      q: "Where can I apply for a passport in La Grande, OR?",
      a: "Passport acceptance facilities near La Grande include the La Grande Post Office, Union County Clerk's office, and Baker City Post Office. For the Wallowa County area, Enterprise Post Office is an option. However, standard processing takes 6–13 weeks. For faster service, use Fast Passport Center's expedited courier processing.",
    },
    {
      q: "Can I get an expedited passport for a Canada or Alaska trip from La Grande?",
      a: "Absolutely. British Columbia hunting and fishing trips are the #1 driver of urgent passport requests from La Grande and Union County. If your passport is expired or expiring before your B.C. hunting trip, start your expedited renewal immediately. Fast Passport Center can process renewals in as little as 3 business days — significantly faster than the USPS.",
    },
    {
      q: "How long does a standard passport take from La Grande, OR?",
      a: "Standard USPS passport processing from La Grande takes 6–13 weeks — and can stretch longer during peak season (May–August). If your trip is within 10 weeks, you need expedited processing. Fast Passport Center offers La Grande travelers processing as fast as 24 hours.",
    },
    {
      q: "Can Eastern Washington residents near La Grande use your service?",
      a: "Yes — Fast Passport Center serves all applicants regardless of their state of residence. Many Wallowa-Whitman National Forest area residents, as well as eastern Washington border communities, use our service. U.S. passport applications are the same regardless of which state you live in.",
    },
    {
      q: "What is the closest airport to La Grande for international flights?",
      a: "La Grande Regional Airport (LGD) offers regional connections. For international flights, the options are Portland International Airport (PDX, about 260 miles west via I-84), Boise Airport (BOI, about 130 miles southeast), and Seattle-Tacoma Airport (SEA, about 340 miles northwest). All require a valid U.S. passport for international departure.",
    },
    {
      q: "Can I renew my passport from La Grande without visiting an office?",
      a: "Yes. Most La Grande-area adults renewing a passport (issued at age 16+ within the last 15 years) can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, receive your checklist, and ship overnight from the La Grande FedEx or UPS location.",
    },
    {
      q: "What if my passport is damaged before an Eastern Oregon hunting trip?",
      a: "A damaged passport — water damage, torn pages, missing cover — is invalid and must be replaced before international travel. Fast Passport Center handles damaged passport replacement with expedited processing so you don't miss your B.C. or Alaska hunting trip.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — La Grande", address: "2401 Island Ave, La Grande, OR 97850", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart — La Grande", address: "1809 Island Ave, La Grande, OR 97850", hours: "Daily 7 AM – 11 PM" },
    { name: "Safeway — La Grande", address: "1412 Adams Ave, La Grande, OR 97850", hours: "Daily 6 AM – 11 PM" },
    { name: "The UPS Store — Pendleton", address: "1340 NW 9th St, Pendleton, OR 97801", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 4 PM" },
    { name: "Walmart — Baker City", address: "3160 10th St, Baker City, OR 97814", hours: "Daily 7 AM – 11 PM" },
    { name: "FedEx — Pendleton", address: "2300 SW Court Pl, Pendleton, OR 97801", hours: "Mon–Fri 8 AM – 7 PM" },
    { name: "Walgreens — Pendleton", address: "1412 SE Court Ave, Pendleton, OR 97801", hours: "Daily 8 AM – 9 PM" },
    { name: "FedEx — Boise (ID)", address: "475 W Parkcenter Blvd, Boise, ID 83706", hours: "Mon–Fri 7 AM – 9 PM" },
    { name: "Walgreens — Ontario", address: "101 SE 1st Ave, Ontario, OR 97914", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart — Ontario", address: "466 SE 1st Ave, Ontario, OR 97914", hours: "Daily 7 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "La Grande Driver & Motor Vehicle Services",
      address: "1206 N 4th St, La Grande, OR 97850",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Primary Union County DMV office. REAL ID, driver licenses, state IDs. Appointment recommended.",
      featured: true,
    },
    {
      name: "Baker City Driver & Motor Vehicle Services",
      address: "2480 Cedar St, Baker City, OR 97814",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Baker County DMV for residents south of La Grande.",
      featured: false,
    },
    {
      name: "Pendleton Driver & Motor Vehicle Services",
      address: "700 SE Nye Ave, Pendleton, OR 97801",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Larger Pendleton DMV option with full REAL ID capabilities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LGD",
      name: "La Grande / Union County Airport",
      distance: "Local general aviation airport — regional connections",
      address: "65198 Old Elgin Hwy, La Grande, OR 97850",
      note: "LGD primarily serves private and charter aviation. Commercial passengers typically drive to Portland or Boise for international flights.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
    {
      code: "BOI",
      name: "Boise Airport",
      distance: "Nearest commercial airport — about 130 miles southeast via I-84",
      address: "3201 Airport Way, Boise, ID 83705",
      note: "BOI is the closest commercial airport to La Grande for most travelers, with connections to major hubs. For direct international flights, PDX or SEA are better options.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "BOI Airport Website",
      featured: false,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international airport — about 260 miles west via I-84",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "PDX is the best option for direct international flights from La Grande area. The 4-hour drive on I-84 is straightforward but requires planning for early departures. Always carry your valid passport — standard processing timelines won't help if you discover an issue at the gate.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Emergency passport for La Grande and Union County travelers — our registered courier service reaches Seattle's passport agency so you don't have to make a 340-mile drive for a same-day appointment.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Emergency replacement for lost passports"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired before your B.C. hunting trip, Alaska adventure, or PDX international flight? Ship overnight from La Grande with no in-person visit required. Processing in as little as 3 business days.",
      bullets: ["No in-person visit for most renewals", "Ship from La Grande or Baker City FedEx/UPS", "3 business days processing available"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before an international trip? We guide La Grande travelers through DS-64 reporting and expedited replacement without requiring a trip to a government office.",
      bullets: ["DS-64 form guidance", "Urgent replacement available", "Remote Eastern Oregon service"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passports for Union County families — minors under 16 require an in-person acceptance visit. We provide complete instructions for the La Grande Post Office acceptance process.",
      bullets: ["Both parents typically required", "Clear checklist provided", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport (First-Time)",
      description: "First passport for La Grande area residents. We guide you through the in-person acceptance step at the La Grande or Baker City post office and handle expedited processing afterward.",
      bullets: ["Acceptance clerk guidance included", "Complete checklist — no guesswork", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — giving La Grande travelers priority access to passport agency submission channels that standard USPS cannot provide.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, and second passports for frequent travelers — all with the same expedited courier access from La Grande.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for La Grande, Oregon travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport Renewal", description: "Fast expedited passport renewal for La Grande and Union County, OR residents." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport service serving La Grande and Eastern Oregon." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for La Grande travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Union County families." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Until B.C. Season to Check Expiration", description: "The single biggest mistake Eastern Oregon hunters make — discovering an expired passport when booking a B.C. hunting license in August. Standard processing takes 6–13 weeks. Check your passport every spring." },
    { icon: "ri-camera-off-line", title: "Poor Passport Photo Quality", description: "Photos with incorrect lighting, shadows, or wrong background cause rejection. We provide exact specifications — Walgreens or FedEx produce consistent results." },
    { icon: "ri-file-damage-line", title: "Incomplete Application Forms", description: "One missing signature or wrong date returns your entire application weeks later. Fast Passport Center reviews every document before submission." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate", description: "Rural Oregon birth certificates sometimes don't meet requirements. We verify exactly what's needed before you make the trip to the post office." },
    { icon: "ri-calendar-close-line", title: "Limited La Grande Post Office Availability", description: "La Grande's passport appointment slots are limited and can book out weeks in advance. Don't rely on walk-in availability — use Fast Passport Center's courier service for predictable processing." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch at PDX or Border", description: "Passport name must match your airline booking exactly. Middle names, name changes after marriage, and hyphenated surnames cause problems at the border and PDX." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your travel date from La Grande. Complete your secure order in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send your document checklist immediately — exactly what you need for your situation in Union County." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Overnight from La Grande", description: "Drop off at FedEx or UPS in La Grande or Baker City. Most are open evenings for after-work drop-offs." },
    { number: "04", icon: "ri-building-2-line", title: "Reserved Agency Submission", description: "We submit through our reserved passport agency slots — no drive to Seattle, no day-long wait." },
    { number: "05", icon: "ri-passport-line", title: "Passport Delivered to You", description: "Your completed passport ships directly to your La Grande or Union County address." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Life-or-death emergencies only",
        "Seattle agency — 340 miles from La Grande",
        "Strict eligibility requirements",
        "All-day wait at the agency",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround for Eastern Oregon",
        "Expert document review included",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Faster than USPS self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access",
        "Limited appointment availability in La Grande",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable for travel within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Seattle agency, 340 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (5+ hours each way)", fpc: "Ship overnight from La Grande FedEx/UPS" },
    { feature: "Processing Speed", agency: "Emergency travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review before submission" },
    { feature: "Rural Support", agency: "No support for remote applicants", fpc: "Dedicated agent for every Union County case" },
    { feature: "Government Shutdowns", agency: "Operations may be suspended", fpc: "Not affected" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Pendleton", route: "/cities/pendleton" },
    { name: "Expedited passport help in Bend", route: "/cities/bend" },
    { name: "Rush passport renewal in The Dalles", route: "/cities/the-dalles" },
    { name: "Fast passport services in Portland", route: "/cities/portland" },
    { name: "Oregon expedited passport guide", route: "/states/oregon" },
  ],
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeNote: "After starting your order online, we send your personalized document checklist and shipping instructions. Ship overnight from La Grande FedEx or UPS in Baker City — no in-person visit to our facility required.",
  fpcOfficeDistance: "Serving La Grande and all of Union County remotely",
  serviceAreaIntro: "Whether you are in La Grande, Union, Elgin, Cove, Enterprise, or anywhere in the Blue Mountains region, Fast Passport Center makes expedited passport processing accessible from remote Eastern Oregon.",
  nearbyCitiesIntro: "We serve all Union County zip codes plus Baker County and the northeast Oregon corner. Ship overnight and your documents reach our processing center the next morning.",
  howItWorksIntro: "Getting an expedited passport from La Grande is simpler than you expect. Start online, ship from your local FedEx or UPS, and we handle everything from there.",
  mistakesIntro: "These are the most common passport mistakes from Eastern Oregon and Union County travelers. Fast Passport Center reviews your documents before submission to prevent costly delays.",
  testimonialsIntro: "Real reviews from La Grande, Baker City, and Eastern Oregon travelers who needed passports fast.",
  faqIntro: "The most common questions from La Grande and Union County residents about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel Timing & Passport Urgency for La Grande, Oregon Residents",
    intro: "La Grande sits at the heart of Eastern Oregon — surrounded by the Blue Mountains, Wallowa Mountains, and easy access to British Columbia. These geography-driven travel patterns create predictable passport urgencies for Union County residents.",
    cards: [
      {
        icon: "ri-map-pin-2-line",
        title: "B.C. Hunting, Fishing & Outdoor Recreation",
        subtitle: "British Columbia border, Aug–Nov season",
        description: "Eastern Oregon is one of the most active B.C. hunting and fishing communities in the Pacific Northwest. La Grande and Union County residents pursue elk, mule deer, moose, steelhead, and salmon in British Columbia every fall. The predictable pattern: hunters discover their passport expired only when booking B.C. hunting licenses — often just 2–4 weeks before their trip. We process dozens of Eastern Oregon hunting renewals each August and September.",
        tip: "Check your passport expiration every spring — well before B.C. hunting and fishing season opens. An expired passport discovered in August with a September hunt booked is a genuine emergency. Standard USPS processing won't help you at that point.",
      },
      {
        icon: "ri-landscape-line",
        title: "Wallowa Mountains & Hells Canyon International Travel",
        subtitle: "Canadian connections, Alaska, Japan adventure travel",
        description: "La Grande and the Wallowa Valley attract serious outdoor adventurers — and those who explore the Wallowa Mountains and Hells Canyon often plan international extensions to Alaska, British Columbia, and Japan. The Eagle Cap Wilderness and Wallowa Lake attract an international visiting community that creates networking opportunities leading to spontaneous international travel for La Grande residents.",
        tip: "Japan and Alaska adventure travel require valid passports. Japan also requires a visa for stays over 90 days. If you're planning a Japan hunting or fishing trip (brown bear, deer), start your passport renewal 6 months in advance.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Eastern Oregon University Study Abroad",
        subtitle: "EOU La Grande — study abroad programs",
        description: "Eastern Oregon University in La Grande sends students abroad each academic year for exchange programs and international studies. Students from rural Union County frequently have their first passport application experience here — and EOU's semester deadlines don't wait for slow USPS processing. Parents of EOU students also travel internationally for study-abroad orientation programs.",
        tip: "EOU students: apply for your passport the semester before your planned study-abroad program. First-time passport applications require an in-person acceptance visit — we provide a complete checklist so you know exactly what to bring to the La Grande post office.",
      },
      {
        icon: "ri-briefcase-line",
        title: "Agricultural & Timber Export Travel",
        subtitle: "Pacific Rim agricultural markets, Japan, Taiwan",
        description: "Union County has significant agricultural and timber operations — cattle ranching, wheat farming, and ponderosa pine logging. Export businesses in the region travel to Japan, Taiwan, and South Korea for agricultural trade and timber sales. These trips often have flexible booking windows but short final confirmation timelines, creating a predictable pattern of last-minute passport renewal requests.",
        tip: "Agricultural export travel to Japan often involves Japan Agricultural Show attendance. Japan requires a valid passport and, for business stays, a business visa. If your passport has less than 12 months remaining, renew before applying for any Japanese visas.",
      },
    ],
    callout: {
      icon: "ri-map-2-line",
      title: "340 Miles from Seattle — We Handle It from La Grande",
      description: "The Seattle Passport Agency is 340 miles from La Grande — a 5-hour drive each way that's simply not practical for most Union County residents, especially hunters with fixed season dates. Fast Passport Center provides La Grande travelers with the same priority access as a Seattle visit — without leaving the Blue Mountains.",
    },
  },
  destinations: {
    title: "Where La Grande Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Union County and Eastern Oregon clients. Each carries a predictable passport urgency we've helped hundreds of travelers navigate.",
    stats: [
      { stat: "Aug–Nov", label: "B.C. hunting and fishing season — the peak period for Eastern Oregon passport emergencies" },
      { stat: "340 Mi", label: "from La Grande to Seattle Passport Agency — making courier service the only practical option" },
      { stat: "130 Mi", label: "from La Grande to Boise Airport — nearest commercial hub for many domestic connections" },
      { stat: "6 Months", label: "minimum passport validity required by Japan, Mexico, and most European countries" },
    ],
    destinations: [
      {
        name: "British Columbia, Canada",
        context: "Hunting, fishing, and outdoor adventure — the dominant international destination for La Grande, Union County, and Wallowa County residents",
        urgency: "B.C. hunting season licenses trigger Aug–Nov passport emergencies across Eastern Oregon",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Japan & Pacific Rim",
        context: "Agricultural trade shows, timber export negotiations, and cultural trips from La Grande's Eastern Oregon community",
        urgency: "Trade travel to Japan has 2–4 week confirmation timelines; Japan visa requires valid passport",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Alaska",
        context: "Brown bear hunting, salmon fishing, and wilderness adventure travel — common for La Grande outdoor enthusiasts who pursue extended Pacific Northwest adventure",
        urgency: "Alaska cruise and ferry bookings from Seattle or Bellingham often confirmed 4–8 weeks out",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Mexico",
        context: "Winter family vacations, agricultural research trips, and retirement scouting from Eastern Oregon retirees looking for warm winter alternatives",
        urgency: "Mexico requires 6 months passport validity; winter bookings from Oregon often confirmed just weeks before departure",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Europe (France, Germany, Spain)",
        context: "Timber trade travel to Germany, wine tourism in France and Spain, and European heritage trips from La Grande's diverse community",
        urgency: "ETIAS electronic travel authorization (coming 2025+) will require pre-registration with a valid passport",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Costa Rica",
        context: "Eco-tourism and wildlife travel popular among Eastern Oregon outdoor community and EOU faculty and students",
        urgency: "Costa Rica requires 6 months validity; winter bookings often confirmed 3–4 weeks in advance",
        icon: "ri-map-pin-2-line",
      },
    ],
    crossLinksTitle: "Explore Other Eastern Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout Eastern Oregon and the Blue Mountains with the same expedited passport processing expertise.",
    crossLinks: [
      { name: "Pendleton", route: "/cities/pendleton" },
      { name: "Bend", route: "/cities/bend" },
      { name: "Portland", route: "/cities/portland" },
    ],
  },
};